import api from "../../../../api";
import { env } from '../../../../env';

const baseurl = env.REACT_APP_API_URL_VASKE;

class LegalMatterClient {
  async LegalMatter(isBackground) {
    try {
      var response = await api.get(baseurl + "/LegalMatter", { isBackground: isBackground });
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }

  async GetAllActiveLegalMatters(isBackground) {
    try {
      var response = await api.get(baseurl + "/LegalMatter/GetActiveLegalMatters", { isBackground: isBackground });
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }

  async CreateLegalMatter(data, isBackground) {
    try {
      var response = await api.post(baseurl + "/LegalMatter", data, { isBackground: isBackground });
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }

  async UpdateLegalMatter(id, data, isBackground) {
    try {
      var response = await api.put(baseurl + "/LegalMatter/" + id, data, { isBackground: isBackground });
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }

  async DeleteLegalMatter(id, isBackground) {
    try {
      var response = await api.delete(baseurl + "/LegalMatter?id=" + id, { isBackground: isBackground });
      return response.data;
    } catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }
  async GetLegalMattersForSelect(isBackground) {
    try {
      var response = await api.get(baseurl + "/LegalMatter/GetLegalMattersForSelect", { isBackground: isBackground });
      return response.data;
    }
    catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
  }
}

export default LegalMatterClient;